// Vendor
import * as React from 'react';
import { LineSvgProps, ResponsiveLine } from '@nivo/line';
import { useInView } from 'react-intersection-observer';
import {
  SPOT_BRAND,
  SPOT_CLEANOUT_LIGHT
} from '@thredup/styleguide/src/variables/colors';

// Internal
import { data } from './data';
import { DEFAULT_CHART_PROPS } from '@src/config/nivo';

const ChartCovidSlump: React.FC = () => {
  // Hooks
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '-200px 0px'
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const initialData = data.map((d: any) => ({
    ...d,
    data: [
      {
        x: '2019',
        y: 0
      },
      {
        x: '2020',
        y: 0
      },
      {
        x: '2021',
        y: 0
      }
    ]
  }));

  const chartData = inView ? data : initialData;
  const colors: { [key: string]: string } = {
    Retail: SPOT_CLEANOUT_LIGHT,
    'Online Secondhand': SPOT_BRAND,
    'Offline Secondhand': '#fdbd55'
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getColors = (bar: any) => {
    return colors[bar.id];
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const toolTipCustom = (d: any) => {
    const { point } = d;

    return (
      <div
        style={{
          backgroundColor: '#fff',
          padding: '9px 12px',
          border: `1px solid ${point.serieColor}`
        }}
      >
        <div
          key={point.id}
          style={{
            padding: '3px 0'
          }}
        >
          <strong>{point.data.x}</strong>
          <br />
          <strong>{point.serieId}</strong>
          <br />
          {point.data.yFormatted} ({point.data.size})
        </div>
      </div>
    );
  };

  const markerProps = {
    axis: 'y',
    lineStyle: { fill: 'none', stroke: 'none' },
    textStyle: {
      fontWeight: 'bold',
      fill: '#4a4a4a',
      fontSize: '14px',
      textAnchor: 'start',
      transform: 'translateX(640px)'
    }
  };

  const lineProps: LineSvgProps = {
    ...DEFAULT_CHART_PROPS,
    axisBottom: {
      tickPadding: 10,
      tickSize: 0
    },
    axisLeft: {
      format: (d) => `${d}%`,
      tickPadding: 25,
      tickSize: -15,
      tickValues: [-25, 0, 25, 50, 75]
    },
    colors: getColors,
    data: chartData,
    enableCrosshair: false,
    enableGridX: true,
    enableGridY: true,
    enablePoints: true,
    enablePointLabel: false,
    enableSlices: false,
    gridXValues: ['2019'],
    gridYValues: [0, -50],
    isInteractive: true,
    lineWidth: 6,
    margin: { top: 30, right: 180, bottom: 30, left: 50 },
    markers: [
      {
        ...markerProps,
        value: 69,
        legend: 'Online Secondhand'
      },
      {
        ...markerProps,
        value: 2,
        legend: 'Offline Secondhand'
      },
      {
        ...markerProps,
        value: -14,
        legend: 'Retail'
      }
    ],
    pointSize: 10,
    tooltip: toolTipCustom,
    useMesh: true,
    xScale: { type: 'point' },
    yFormat: (d) => `${d}%`,
    yScale: {
      type: 'linear',
      min: -50,
      max: 75,
      reverse: false
    }
  };

  return (
    <span ref={ref}>
      <ResponsiveLine {...lineProps} />
    </span>
  );
};

export { ChartCovidSlump };
